import{jsx as n}from"react/jsx-runtime";import{styled as t}from"styled-components";import{HashLink as e}from"../../base/HashLink/HashLink.mjs";const r=t.ul`
  padding: 0px;
  padding-bottom: 4px;
  margin: 0px;
`,i=t.li`
  background: url('images/link.png') no-repeat scroll left center transparent;
  display: inline;
  margin: 0 2px;
  padding: 0 0 0 10px;
`,o=t(e)`
  color: #f0f8ff;
  text-decoration: none;
  font-size: 8pt;
`;function p({menuItems:t}){return n(r,{children:t.map((({displayName:t,to:e},r)=>n(i,{children:n(o,{to:e,children:`${t} `})},r)))})}export{p as SubMenu};
